import { useEffect } from "react"
import { ExperimentFlags } from "data/experiment"
import { useExperimentContext } from "components/ExperimentProvider"
import { useExperimentViewed } from "tracking/hooks/useExperimentViewed"

// this hook is only used for experimentation
// we want to know if pre requestite flags could offer even bucketing on nested % rollout

// 0 = Control
// 1 = Variant
const enabledTrackingVariants = [0, 1]

export const usePreRequisteFlagTracking = () => {
  const { getValue } = useExperimentContext()
  const trackExperimentViewed = useExperimentViewed()

  const productFirstPlusFlag =
    Number(getValue(ExperimentFlags.PAGE_EXPERIMENT_PRODUCT_FIRST_PLUS)) ?? 2

  const productFirstMiniFlag = Number(
    getValue(ExperimentFlags.PAGE_EXPERIMENT_PRODUCT_FIRST_MINI) ?? 2
  )

  useEffect(() => {
    if (
      !Number.isNaN(productFirstPlusFlag) &&
      enabledTrackingVariants.includes(productFirstPlusFlag)
    ) {
      trackExperimentViewed(
        ExperimentFlags.PAGE_EXPERIMENT_PRODUCT_FIRST_PLUS,
        productFirstPlusFlag
      )
    }
    if (
      !Number.isNaN(productFirstMiniFlag) &&
      enabledTrackingVariants.includes(productFirstMiniFlag)
    ) {
      trackExperimentViewed(
        ExperimentFlags.PAGE_EXPERIMENT_PRODUCT_FIRST_MINI,
        productFirstMiniFlag
      )
    }
  }, [productFirstPlusFlag, productFirstMiniFlag, trackExperimentViewed])
}
